import React, { useState } from 'react';
import ParticipantList from './participantList';
import GameButton from './GameButton';
import CopyLink from './CopyLink';

import ReactHlsPlayer from 'react-hls-player';
const QRCode = require('qrcode.react');

const GetStartedComponent = (ctx) => {
  const {
    submitted,
    setSubmitted,
    setGlobalError,
    totalParticipants,
    startMeet,
    participants,
    meet,
    isOwner,
    sharingLink,
    plan,
  } = ctx;
  const [showStartLaterMessage, setShowStartLaterMessage] = useState(false);
  const [showInviteLink, setShowInviteLink] = useState(false);
  const [introVideoViewed, setIntroVideoViewed] = useState(false);

  function getStarted() {
    setShowInviteLink(true);
  }

  function introViewed() {
    setIntroVideoViewed(true);
  }

  function toggleStartLaterMessage(e) {
    e.preventDefault();
    setShowStartLaterMessage(!showStartLaterMessage);
  }

  function startMeetClick() {
    if (participants.length < 1) {
      setGlobalError('You need at least one player to start the game');
      return;
    }
    startMeet();
  }

  return (
    <div>
      <h1 className="title">{meet.name}</h1>
      {isOwner ? (
        <div>
          <p>
            Great work {meet.owner}. You&apos;re the{' '}
            <span className="has-text-weight-bold">Race Master</span>.
            There&apos;s some things you should know before we get started.
          </p>
          <div className="section">
            <ul className="instructionsList">
              <li>
                <article className="message is-dark">
                  <div className="message-body">
                    <h2 className="subtitle">You control the racing</h2>
                    <p>
                      If you press any{' '}
                      <span className="button is-link shift-up-7">
                        Blue Buttons
                      </span>
                      , that will change{' '}
                      <span className="has-text-weight-bold">
                        EVERYONE&apos;
                      </span>
                      s screen
                    </p>
                    <p>
                      You use these buttons to move the evening along: Go to the
                      next race... See race results... Things of that nature.
                    </p>
                  </div>
                </article>
              </li>
              <li>
                <article className="message is-dark">
                  <div className="message-body">
                    <h2 className="subtitle">
                      Do you want to play and place some bets too?
                    </h2>
                    <p>
                      If you want to play along as well as running the event
                      (you should do... it&apos;s fun!), make sure you join from
                      your phone too!
                    </p>
                  </div>
                </article>
              </li>
            </ul>
          </div>
          <div>
            <p>
              I think that&apos;s all you need to know for now. Probably time to
              get started.{' '}
              <span className="has-text-weight-bold">Have fun!</span>
            </p>
            <br />
            <br />
          </div>
          {showInviteLink ? (
            <div>
              {meet.includeIntroVideo && !introVideoViewed ? (
                <div>
                  <article className="message is-success">
                    <div className="message-header">
                      <p>Share your screen and play the video</p>
                    </div>
                    <div className="message-body">
                      <ReactHlsPlayer
                        crossOrigin="anonymous"
                        src={
                          'https://vod-live-destination-12yuql6c1wh6m.s3.eu-west-2.amazonaws.com/848e78ef-1c2c-4928-aca1-6c03d5b436b0/hls/Track+-+Night+-+Corporate+Explainer_A9.m3u8'
                        }
                        autoPlay={false}
                        controls={true}
                        width="100%"
                        height="auto"
                      />
                    </div>
                  </article>
                  <GameButton
                    action={introViewed}
                    setGlobalError={setGlobalError}
                    setSubmitted={setSubmitted}
                    submitted={submitted}
                    text="Invite Players"
                  />
                  <br />
                  <br />
                </div>
              ) : (
                <div>
                  <article className="message is-success">
                    <div className="message-header">
                      <p>
                        Share your screen and get everyone to point their phones
                        at the QR code.
                      </p>
                    </div>
                    <div className="message-body">
                      <div className="pad-bottom">
                        <QRCode
                          style={{ width: '400px', height: '400px' }}
                          value={sharingLink()}
                        />
                      </div>
                      <h2 className="subtitle">
                        Someone having problems with the QR Code?
                      </h2>
                      <p>Send them this link:</p>
                      <div>
                        <strong>
                          <CopyLink link={sharingLink()} />
                        </strong>
                      </div>
                      <br />
                    </div>
                  </article>

                  <br />
                  {participants.length > 0 ? (
                    <div>
                      <h2 className="subtitle">
                        There {totalParticipants > 1 ? 'are' : 'is'}{' '}
                        {totalParticipants}{' '}
                        {totalParticipants > 1 ? 'people' : 'person'} ready
                      </h2>
                      <ParticipantList
                        participants={participants || []}
                        totalParticipants={totalParticipants}
                      />
                    </div>
                  ) : null}
                  <div className="section has-text-centered">
                    <GameButton
                      action={startMeetClick}
                      setGlobalError={setGlobalError}
                      setSubmitted={setSubmitted}
                      submitted={submitted}
                      text="Start Meet"
                    />
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div>
              <h1 className="title">Are you ready to play?</h1>
              <p>
                If you&apos;re on your video call, or have everyone assembled at
                the venue, it&apos;s time to invite the players. Click the
                button below to invite everyone.{' '}
                {plan && plan.isPaid ? (
                  <a href="#" onClick={toggleStartLaterMessage}>
                    <strong>Not ready to start yet?</strong>
                  </a>
                ) : null}
              </p>
              <p>
                <strong>
                  If you want to also play along, make sure you join from your
                  own phone too!
                </strong>
              </p>
              <a className="button is-large is-link" onClick={getStarted}>
                {meet.includeIntroVideo ? 'Get Started' : 'Invite Players'}
              </a>
            </div>
          )}
        </div>
      ) : (
        <div>
          <p className="playerGameStatus">The event hasn&apos;t started yet.</p>
          <br />
          <h1 className="subtitle">Players</h1>
          <ParticipantList participants={participants || []} />
        </div>
      )}

      <div className={showStartLaterMessage ? 'modal is-active' : 'modal'}>
        <div className="modal-background"></div>
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">Not ready to play yet?</p>
          </header>
          <section className="modal-card-body">
            <p>
              If you&apos;re not ready to start yet, it&apos;s not a problem.
            </p>
            <br />
            <p>
              We&apos;ve sent you an email with details on how to get back to
              this page when you&apos;re ready to play. If you can&apos;t find
              it <strong>you may need to check your spam folder</strong>.
            </p>
            <p>We look forward to seeing you then!</p>
          </section>
          <footer className="modal-card-foot">
            <button onClick={toggleStartLaterMessage} className="button">
              Close
            </button>
          </footer>
        </div>
      </div>
      <style jsx>{`
        .shift-up-7 {
          top: -7px;
        }
        .pad-bottom {
          padding-bottom: 1em;
        }
        .instructionsList li {
          margin-bottom: 2.5em;
        }
      `}</style>
    </div>
  );
};

export default GetStartedComponent;
